
<template>

  <div class="wrap-v-select">

    <v-select v-model="value"
              :label="label"
              :options="options"
              :reduce="reduce"
              @input="emitValue()"
              >
    </v-select>

  </div>

</template>

<script>
export default{

  model: {
    prop: 'modelValue',
    event: 'input', // nel nostro caso
  },

  props: {

    modelValue: {
      // type: [Object, String, Number, Boolean],
      default: null
    },

    label: {
      type: String,
      default: 'label',
    },

    options: {
      type: Array,
      default: [],
    },

    reduce: {
      type: Function,
      default: option => option,
    },

  },

  data: function(){

    return {
      value: this.modelValue,
    }

  },

  methods: {

    emitValue: function(){

      this.$emit('input', this.value);

    }

  },

  // watch: {
  //
  //   modelValue: function () {
  //
  //     this.emitValue();
  //
  //   }
  //
  // }

}
</script>

<style scoped>

</style>
